import { Component, ElementRef, ViewChild } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {
  distinctUntilChanged,
  Observable,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import * as agGrid from 'ag-grid-community';
import { routes } from '../../../../shared/routes/routes';
import { DataService } from '../../../../shared/data/data.service';
import { HistoryPaginationService } from '../../../../shared/custom-pagination-history/history-pagination.service';
import { ApiService } from '../../../../api.service';
import { CommonService } from '../../../../shared/common/common.service';

@Component({
  standalone: false,
  selector: 'app-history-medi-consult',
  templateUrl: './history-medi-consult.component.html',
  styleUrls: ['./history-medi-consult.component.scss'],
})
export class HistoryMediConsultComponent {
  public routes = routes;
  userProfile: any = {};
  completionPercentage = 0;
  showApology = false;
  dependentData: any = [];
  userSubscription: any = {};
  featureNames: any = [];
  selectedTabIndex = 0;
  showLogoutConfirm = false;
  showApologies: boolean = false;
  public searchDataValue = '';
  selected_id: any;
  subDetail: any;
  telemedicineFeature: any;
  reportIdToDelete: any;
  showDeleteModal: boolean = false;
  private destroy$ = new Subject<void>();

  public pageSize = 10;
  public serialNumberArray: Array<number> = [];
  public totalData = 0;
  showFilter = false;
  private paginationSubscription!: Subscription;
  recordListing: any = [];
  paging: number[] = [];
  currPage: number = 0;
  private prevPageSize: number = 0;
  gridReady = false;
  rowData: any = [];
  gridOptions!: agGrid.GridOptions;
  @ViewChild(HistoryMediConsultComponent)
  HistoryComponent!: HistoryMediConsultComponent;
  @ViewChild('agGrid') agGrid: AgGridAngular | any;
  public tooltipHideDelay = 2000;
  @ViewChild('filtertextbox') filtertext!: ElementRef;
  SerachedRow: number | undefined;
  private gridApi: any;
  private gridColumnApi: any;
  paginationPageSize = 10;
  pages: number[] = [];
  totalPages: number = 0;
  currentPage: number = 1;
  visiblePageCount = 5;
  totalRecords = 0;
  totalPage: number = 0;
  public tooltipShowDelay = 0;
  lastElementOfPage: number = 0;
  NoRecordsFound!: boolean;
  defaultColDef: agGrid.ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };
  colDefs: agGrid.ColDef[] = [
    {
      headerName: 'S.NO',
      valueGetter: (params: any) => params.node.rowIndex + 1,
      minWidth: 80,
      flex: 0.5,
      editable: false,
      resizable: true,
      filter: false,
      sortable: true,
      lockPosition: true,
    },
    {
      headerName: 'Booking Date',
      valueGetter: (params: any) => {
        const rawDate = params.data?.booking_date;
        if (!rawDate) return '';
        const date = new Date(rawDate);
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare'
        });
      },
      editable: false,
      resizable: true,
      minWidth: 150,
      flex: 1,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      cellStyle: { marginLeft: '-8px' },
    },
    {
      headerName: 'Doctor Name',
      valueGetter: (params: any) => {
        const first = params.data?.doctor_first_name || '';
        const last = params.data?.doctor_last_name || '';
        return `${first} ${last}`.trim();
      },
      minWidth: 150,
      flex: 1,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      cellStyle: { marginLeft: '-8px' },
    },
    {
      headerName: 'Specialization',
      field: 'specialization',
      editable: false,
      resizable: true,
      minWidth: 150,
      flex: 1,
      filter: true,
      sortable: true,
      lockPosition: true,
      cellStyle: { marginLeft: '-8px' },
    },
    {
      headerName: 'Booking Channel',
      field: 'booking_channel_id',
      valueGetter: (params: any) => {
        return params.data.booking_channel_id === 1 ? 'WEB' : 'N/A';
      },
      editable: false,
      resizable: true,
      minWidth: 150,
      flex: 1,
      filter: true,
      sortable: true,
      lockPosition: true,
      cellStyle: { marginLeft: '-10px' },
    },
    {
      headerName: 'Prescription',
      field: 'prescription',
      editable: false,
      resizable: true,
      minWidth: 150,
      flex: 1,
      filter: true,
      sortable: true,
      lockPosition: true,
      cellStyle: { marginLeft: '-8px' },
    },
    {
      headerName: 'Status',
      field: 'tc_booking_status',
      editable: false,
      resizable: true,
      minWidth: 150,
      flex: 1,
      filter: true,
      sortable: true,
      lockPosition: true,
    },
  ];

  constructor(
    private data: DataService,
    private pagination: HistoryPaginationService,
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private commonService: CommonService
  ) {}
  ngOnInit() {
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    this.subDetail = JSON.parse(localStorage.getItem('subDetail') || '{}');
    this.gridOptions = {
      alwaysShowHorizontalScroll: true,
      includeHiddenColumnsInQuickFilter: true,
      defaultColDef: {
        filter: 'agTextColumnFilter',
        filterParams: {
          buttons: ['reset'],
          resetButton: true,
        },
      },
      localeText: {
        filterOoo: 'Filter...',
        resetFilter:
          '<img class="filter_icon" src="../../../../assets/images/filter-clear.svg" alt="">Clear',
      },
      suppressScrollOnNewData: true,
      rowSelection: 'multiple',
      rowMultiSelectWithClick: true,
      headerHeight: 50,
      suppressRowClickSelection: true,
      suppressDragLeaveHidesColumns: true,
      groupSelectsChildren: true,
      paginationPageSize: 15,
      pagination: true,
      paginateChildRows: true,
      overlayNoRowsTemplate: `
  <div style="
    display: flex; 
    justify-content: center; 
    align-items: center;
  ">
    <div style="
      padding: 16px 14px; 
      margin-top: -20px;
      background: white; 
      box-shadow: 0 4px 14px rgba(105, 95, 151, 0.18); 
      border-radius: 8px; 
      font-size: 16px; 
      color: #444;
      font-weight: 500;
    ">
      No records to show
    </div>
  </div>
`,
    };
    this.getReports(this.userProfile.user_id);
  }

  getReports(id: any): void {
    this.apiService.getActiveTelemedicineHistory(id).subscribe({
      next: (apiRes: any) => {
        this.rowData = apiRes.data.map((item: any) => ({
          tc_booking_id: item.tc_booking_id ?? 'N/A',
          user_id: item.user_id ?? 'N/A',
          country_dial_code: item.country_dial_code ?? 'N/A',
          phone_number: item.phone_number ?? 'N/A',
          doctor_id: item.doctor_id ?? 'N/A',
          slot_id: item.slot_id ?? 'N/A',
          booking_date: item.booking_date ?? 'N/A',
          booking_time: item.booking_time ?? 'N/A',
          booking_channel_id: item.booking_channel_id ?? 'N/A',
          consultation_type: item.consultation_type ?? 'N/A',
          tc_plan_type: item.tc_plan_type ?? 'N/A',
          tc_booking_status: item.tc_booking_status ?? 'N/A',
          reason_for_consultation: item.reason_for_consultation ?? 'N/A',
          channel_id: item.channel_id ?? 'N/A',
          prescription: item.prescription ?? 'N/A',
          is_al_carte: item.is_al_carte ?? 'N/A',
          a_la_carte_payment_id: item.a_la_carte_payment_id ?? 'N/A',
          consultation_notes: item.consultation_notes ?? 'N/A',
          created_by_user_id: item.created_by_user_id ?? 'N/A',
          updated_by_user_id: item.updated_by_user_id ?? 'N/A',
          is_deleted: item.is_deleted ?? 'N/A',
          deletedAt: item.deletedAt ?? 'N/A',
          createdAt: item.createdAt ?? 'N/A',
          updatedAt: item.updatedAt ?? 'N/A',
          user_first_name: item.user?.first_name ?? 'N/A',
          user_last_name: item.user?.last_name ?? 'N/A',
          user_phone: item.user?.phone ?? 'N/A',
          user_email: item.user?.email ?? 'N/A',
          user_profile: item.user?.profile ?? 'N/A',
          doctor_first_name: item.doctor?.first_name ?? 'N/A',
          doctor_last_name: item.doctor?.last_name ?? 'N/A',
          ConsultAlaCartePayment: item?.ConsultAlaCartePayment,
        }));
        if (this.gridApi && this.gridApi.paginationGetTotalPages) {
          this.totalPage = this.gridApi.paginationGetTotalPages();
          this.getLastPage();
        }
      },
      error: () => {
        // this.toastrService.error('Failed to fetch ambulance data');
      },
    });
  }

  moveTosubcription() {
    this.router.navigate([routes.patientSubscription]);
  }

  getLastPage() {
    setTimeout(() => {
      if (this.currPage * this.paginationPageSize > this.rowData?.length) {
        this.lastElementOfPage = this.rowData?.length;
      } else {
        this.lastElementOfPage = this.currPage * this.paginationPageSize;
      }
    }, 50);
  }

  gotoPage(page: number) {
    this.gridApi.paginationGoToPage(page - 1);
    this.getLastPage();
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onBtFirst() {
    if (this.gridApi.paginationGetTotalPages() > 1) {
      this.gridApi.paginationGoToFirstPage();
      this.currPage = this.gridApi.paginationGetCurrentPage() + 1;
    }
  }

  onBtLast() {
    if (this.gridApi.paginationGetTotalPages() > 1) {
      this.gridApi.paginationGoToLastPage();
      this.currPage = this.gridApi.paginationGetCurrentPage() + 1;
    }
  }

  onBtNext() {
    this.gridApi.paginationGoToNextPage();
    this.currPage = this.gridApi.paginationGetCurrentPage() + 1;
  }

  onBtPrevious() {
    this.gridApi.paginationGoToPreviousPage();
    this.currPage = this.gridApi.paginationGetCurrentPage() + 1;
  }

  onChangePageSize() {
    setTimeout(() => {
      this.totalPage = this.gridApi.paginationGetTotalPages();
    }, 50);
  }

  onPaginationChanged() {
    const newPageSize = this.gridApi.paginationGetPageSize();
    this.totalPage = this.gridApi.paginationGetTotalPages();
    this.paging = [];
    this.getLastPage();
    if (this.prevPageSize !== newPageSize) {
      this.prevPageSize = newPageSize;
      const maxPagesToShow = 5;
      this.currPage = Math.min(this.currPage, this.totalPage);

      if (this.totalPage <= maxPagesToShow) {
        this.paging = Array.from({ length: this.totalPage }, (_, i) => i + 1);
      } else {
        const newVisiblePage = Math.ceil(
          this.currPage / (newPageSize / this.paginationPageSize)
        );
        const tabStartPage = Math.max(
          1,
          (newVisiblePage - 1) * maxPagesToShow + 1
        );
        const tabEndPage = Math.min(
          tabStartPage + maxPagesToShow - 1,
          this.totalPage
        );
        if (this.totalPage === 0) {
          this.paging = Array.from(
            { length: this.paginationPageSize },
            (_, i) => 0
          );
        } else {
          const adjustedTabStartPage = Math.max(
            1,
            newVisiblePage - Math.floor(maxPagesToShow / 2)
          );
          for (let i = adjustedTabStartPage; i <= tabEndPage; i++) {
            this.paging.push(i);
          }
        }
      }
    }

    this.currPage = this.gridApi.paginationGetCurrentPage() + 1;

    if (this.totalPage === 0) {
      this.currPage = 0;
      this.lastElementOfPage = 0;
      this.paging = [];
      this.gridApi.showNoRowsOverlay();
    } else {
      const maxPagesToShow = 5;
      const startPage = Math.max(1, this.currPage);
      const pagging = this.paging.slice();
      this.paging = [];
      if (pagging.includes(this.currPage) && this.totalPage <= maxPagesToShow) {
        this.paging = Array.from({ length: this.totalPage }, (_, i) => i + 1);
      } else {
        const tabStartPage =
          Math.floor((Math.max(this.currPage, 1) - 1) / maxPagesToShow) *
            maxPagesToShow +
          1;
        const tabEndPage = Math.min(
          tabStartPage + maxPagesToShow - 1,
          this.totalPage
        );
        for (let i = tabStartPage; i <= tabEndPage; i++) {
          this.paging.push(i);
        }
      }
      this.currPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.gridApi.hideOverlay();
    }
    this.SerachedRow = this.gridApi.getModel().getRowCount();
    if (this.totalPage == 0) {
      this.SerachedRow = 0;
      this.NoRecordsFound = false;
    }
  }

  onFilterTextBoxChanged() {
    const filterText = this.filtertext.nativeElement.value;
    this.gridApi.setQuickFilter(filterText);
    setTimeout(() => {
      const rowCount = this.gridApi.getModel().getRowCount();
      this.SerachedRow = rowCount;
      this.NoRecordsFound = rowCount === 0;
      if (rowCount === 0) {
        this.gridApi.showNoRowsOverlay();
      } else {
        this.gridApi.hideOverlay();
      }
    }, 100);
  }
}
